
<div class="row" style="text-align: center;">
        <div class="csf1" (click)="redirectToHome()" > <i class="pi pi-home ccolor"></i> {{ 'DASHBOARD_NAV' | translate}}</div>
        <p-divider></p-divider>
        <div class="csf1" (click)="redirectToChat()"> <i class="pi pi-comment ccolor"></i> {{ 'CHATS_NAV' | translate}}</div>
        <p-divider></p-divider>
        <div class="csf1" (click)="redirectToDevices()"> <i class="pi pi-phone ccolor"></i> {{ 'DEVICES_NAV' | translate}}</div>
        <p-divider></p-divider>
        <div class="csf1" (click)="redirectToAccoount()"> <i class="pi pi-user ccolor"></i> {{ 'ACCOUNT_NAV' | translate}}</div>
        <p-divider></p-divider>
        <div class="csf1" (click)="redirectToUser()"> <i class="pi pi-users ccolor"></i> {{ 'USERS_NAV' | translate}}</div>
        <p-divider></p-divider>
        <div class="csf1" (click)="redirectToSettings()"> <i class="pi pi-fw pi-cog ccolor"></i> {{ 'SETTINGS_NAV' | translate}}</div>
        <p-divider></p-divider>
        <div class="csf1" (click)="redirectToCampaigns()"> <i class="pi pi-send ccolor"></i> {{ 'CAMPAIGNS_NAV' | translate}}</div>
</div>